import React, { useEffect, useState } from 'react';
import { MySelect } from '../../Select/Select';
import { useForm } from 'react-hook-form';
import Axios from 'axios';
import { useSnackbar } from 'notistack';

const Year = ({ onChangeYear, defaultSubmitFirstParams = false }) => {
   const [years, setYears] = useState();
   const { enqueueSnackbar, closeSnackbar } = useSnackbar();

   const {
      control,
      register,
      watch,
      setValue,
      getValues,
      handleSubmit,
      unsubscribe,
   } = useForm({
      defaultValues: {
         year: new Date().getFullYear(),
      },
   });

   const selectedYear = watch('year');

   useEffect(() => {
      register({ name: 'year' });
   }, [register]);

   useEffect(() => {
      init();
   }, []);

   const init = async () => {
      let { years, defaultYear } = await getYearsDropdown();
      setYears(years);
      if (defaultSubmitFirstParams) {
         if (years.length > 0) {
            setValue('year', defaultYear);
            onChangeYear(defaultYear.value);
         }
      }
   };

   const toDropdownYear = (arr) => {
      return arr.map((el) => {
         return {
            label: el,
            value: el,
         };
      });
   };

   const getYearsDropdown = () => {
      return Axios.get('/GSB/dashboard/dashboard/GetDropDownYear')
         .then((resp) => {
            return {
               years: toDropdownYear(resp.data.dropdownYears),
               defaultYear: {
                  label: resp.data.defaultYear,
                  value: resp.data.defaultYear,
               },
            };
         })
         .catch((e) => {
            if (e.response) {
               const response = e.response.data;
               enqueueSnackbar(e.response.data.errorAppMessageTh, {
                  variant: 'error',
               });
            } else {
               console.error('site error');
            }
            return false;
         })
         .finally(() => {});
   };

   const handleChangeYear = (selected) => {
      setValue('year', selected);
      if (selected) {
         onChangeYear(selected.value);
      }
   };

   return (
      <div>
         <MySelect
            clearable
            closeMenuOnSelect
            options={years}
            placeholder={'เลือกปี'}
            value={selectedYear}
            onChange={handleChangeYear}
            isClearable={false}
         />
      </div>
   );
};

export default Year;
